import { render } from "./Username.vue?vue&type=template&id=34970e19&ts=true"
import script from "./Username.vue?vue&type=script&lang=ts"
export * from "./Username.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Users\\orson\\coding\\thelounge\\thelounge\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/Username.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "34970e19"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('34970e19', __exports__)) {
    api.reload('34970e19', __exports__)
  }
  
  module.hot.accept("./Username.vue?vue&type=template&id=34970e19&ts=true", () => {
    api.rerender('34970e19', render)
  })

}


export default __exports__